import { Provider } from 'mobx-react';
import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { modalStore } from 'ws-react-modal-dialog';
import { DynamicImport, NotFound } from 'ws-voice-infinity-global-module/lib/components';
import { UtilService } from 'ws-voice-infinity-global-module/lib/services';
import { authStore, eventStore, globalStore, mainPageStore, notificationStore, oktmoStore, userStore } from 'ws-voice-infinity-global-module/lib/store';
import MainWrap from '../modules/Wrappers/mainWrap/mainWrapComponent';

const stores = { authStore, eventStore, globalStore, mainPageStore, modalStore, oktmoStore, userStore, notificationStore };

export default class MainRouter extends React.Component<{
    history?: any;
    location?: any;
}> {
    render() {
        return (
            <Provider
                {...stores}
            >
                <HashRouter>
                    <Switch>
                        <MainWrap
                            location={this.props.location}
                        >
                            <Switch>
                                <Route
                                    exact
                                    path={'/'}
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Main/pages/mainPage/mainPage')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path={'/card/:id'}
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Main/pages/mainCard/mainCard')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path={'/card/:id/complaints-list'}
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Main/pages/objectComplaintsList/objectComplaintsList')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path={'/new-request'}
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Lifecity/pages/requestCreateForm/requestCreateForm')}
                                        propsParent={props}
                                    />}
                                />
                                {
                                    UtilService.isR41() &&
                                    <Route
                                        exact
                                        path={'/npa-list'}
                                        component={(props: any) => <DynamicImport
                                            load={() => import('../modules/Lifecity/pages/npa/npaListContainer')}
                                            propsParent={props}
                                        />}
                                    />
                                }
                                {
                                    UtilService.isR41() &&
                                    <Route
                                        exact
                                        path={'/history-project'}
                                        component={(props: any) => <DynamicImport
                                            load={() => import('../modules/Lifecity/pages/historyProject/historyProjectContainer')}
                                            propsParent={props}
                                        />}
                                    />
                                }
                                <Route
                                    component={NotFound}
                                />
                            </Switch>
                        </MainWrap>
                        <Route
                            component={NotFound}
                        />
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}
